import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { AppWrap } from "../../wrapper";
import "./Header.scss";
import profileImage from "../../assets/profile.png";
import { client } from "../../client";

const Header = () => {
  const [resumeUrl, setResumeUrl] = useState("");
  const [fileName, setFileName] = useState("Resume.pdf");

  const [profileImageUrl, setProfileImageUrl] = useState(profileImage);
  const [profileImageAlt, setProfileImageAlt] = useState("Profile Image");

  useEffect(() => {
    client
      .fetch(
        `{
        "resume": *[_type == "resume"] | order(_createdAt desc)[0]{resumeFile{asset->{url, originalFilename}}},
        "profile": *[_type == "profile"] | order(_createdAt desc)[0]{profileImage{asset->{url, originalFilename}}, customImageName}
      }`
      )
      .then((data) => {
        if (data?.resume?.resumeFile?.asset?.url) {
          setResumeUrl(data.resume.resumeFile.asset.url);
          setFileName(
            data.resume.resumeFile.asset.originalFilename || "Resume.pdf"
          );
        }
        if (data?.profile?.profileImage?.asset?.url) {
          setProfileImageUrl(data.profile.profileImage.asset.url);
          setProfileImageAlt(
            data.profile.customImageName?.trim() ||
              data.profile.profileImage.asset.originalFilename?.trim() ||
              "Profile Image"
          );
        }
      })
      .catch(console.error);
  }, []);

  return (
    <>
      <div className="app__header app__flex">
        <motion.div
          whileInView={{ x: [-100, 0], opacity: [0, 1] }}
          transition={{ duration: 0.5 }}
          className="app__header-info"
        >
          <div className="app__header-badge">
            <div className="badge-cmp app__flex">
              <div style={{ marginLeft: 20 }}>
                <p className="p-text">
                  <span>👋</span> Hello, I am
                </p>
                <h1 className="head-text">Abdelmounim MOUADILI</h1>
              </div>
            </div>

            <div className="tag-cmp app__flex">
              <p className="p-text">Full-Stack Developer</p>
              <p className="p-text">Freelancer</p>
            </div>

            {/* Resume Button */}
            {resumeUrl && (
              <a
                href={resumeUrl}
                download={fileName}
                className="app__header-button"
              >
                Download Resume
              </a>
            )}
          </div>
        </motion.div>

        <motion.div
          whileInView={{ opacity: [0, 1] }}
          transition={{ duration: 0.5, delayChildren: 0.5 }}
          className="app__header-img"
        >
          {profileImageUrl && (
            <motion.img
              whileInView={{ scale: [0, 1] }}
              transition={{ duration: 1, ease: "easeInOut" }}
              src={profileImageUrl}
              alt={profileImageAlt}
              className="profile__image"
            />
          )}
        </motion.div>
      </div>
    </>
  );
};

export default AppWrap(Header, "home");
